'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.core.notification.types.hipchat', [])
  .config(function(notificationTypeConfigProvider) {
    notificationTypeConfigProvider.registerNotificationType({
      label: 'HipChat',
      key: 'hipchat',
      addressTemplateUrl: require('./additionalFields.html')
    });
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/notification/types/hipchat/hipchat.notification.type.module.js